
import { Component, Vue } from 'vue-property-decorator';
import SetSupportLvl from '@/components/user/SetSupportLvl.vue';
import MyAccounts from '@/components/user/MyAccounts.vue';
import AddMyAccount from '@/components/user/AddMyAccount.vue';
import Installer from '@/components/user/Installer.vue';

import userx from '../store/modules/userx';
import mwx from '../store/modules/mediumwarex';

@Component({
	components: {
		SetSupportLvl,
		MyAccounts,
		Installer,
	},
})
export default class Home extends Vue {
	public get supportLvl() {
		return userx.user && userx.user.supportLvl;
	}
	public get allAccounts() {
		return mwx.allAccounts;
	}
}
